import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button,Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { useHistory } from 'react-router';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const AptevoQuarterlyServiceFeesPage = () => {
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const userData = JSON.parse(localStorage.getItem('userData'));
    const history = useHistory();
    const fileName = 'Aptevo Quarterly ServiceFees';
    const [salesSource, setSalesSource] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [showToaster, setShowToaster] = useState(false);
    // let Message;
    const [hasError, setHasError] = useState(false);
    // excel Headers
    const excelColumns = [

        {
            Header: "DISTRIBUTOR NAME",
            accessor: "DistributorName",
            filter: "DistributorName",
            sortType: "basic",
        },
        {
            Header: "DISTRIBUTION LOCATION STATE",
            accessor: "DistributionLocationState",
            filter: "DistributionLocationState",
            sortType: "basic",
        },
        {
            Header: "REPORT DATE",
            accessor: "ReportDate",
            filter: "ReportDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
       
        {
            Header: "DEBIT MEMO#",
            accessor: "DebitMemoNum",
            filter: "DebitMemoNum",
            sortType: "basic",
        },
        {
            Header: "Customer Hin",
            accessor: "CustID",
            filter: "CustID",
            sortType: "basic",
        },
        {
            Header: "CB CUST PHS ID# (For applicable CBs only)",
            accessor: "CustPHSID",
            filter: "CustPHSID",
            sortType: "basic",
        },
        {
            Header: "CUSTOMER NAME",
            accessor: "CustName",
            filter: "CustName",
            sortType: "basic",
            width:350
        },
        {
            Header: "CUSTOMER ADDRESS",
            accessor: "CustAddress",
            filter: "CustAddress",
            sortType: "basic",
            width:300
        },
        {
            Header: "CUSTOMER CITY",
            accessor: "CustCity",
            filter: "CustCity",
            sortType: "basic",
        },
        {
            Header: "CUSTOMER STATE",
            accessor: "CustState",
            filter: "CustState",
            sortType: "basic",
        },
        {
            Header: "CUSTOMER ZIP",
            accessor: "CustZip",
            filter: "CustZip",
            sortType: "basic",
        },
        {
            Header: "CUSTOMER'S INVOICE#",
            accessor: "CustomersInvoice",
            filter: "CustomersInvoice",
            sortType: "basic",
        },
        {
            Header: "CUSTOMER'S INVOICE DATE",
            accessor: "CustomersInvoiceDate",
            filter: "CustomersInvoiceDate",
            sortType: "basic",
        },
        {
            Header: "CONTRACT REFERENCE",
            accessor: "ContractReference",
            filter: "ContractReference",
            sortType: "basic",
        },
        {
            Header: "PRODUCT NDC-11",
            accessor: "ProductNDC",
            filter: "ProductNDC",
            sortType: "basic",
        },
        {
            Header: "PRODUCT DESCRIPTION",
            accessor: "ProductDescription",
            filter: "ProductDescription",
            sortType: "basic",
            width:300
        }, {
            Header: "SALE QTY",
            accessor: "SaleQTY",
            filter: "SaleQTY",
            sortType: "basic",
        },
        {
            Header: "SALE QTY UOM",
            accessor: "SaleQTYUOM",
            filter: "SaleQTYUOM",
            sortType: "basic",
        },
        {
            Header: "DOSAGE / UNITS",
            accessor: "DosagORUnitstabs30",
            filter: "DosagORUnitstabs30",
            sortType: "basic",
        },
        {
            Header: "DOSAGE / UNITS UOM",
            accessor: "DosageORUnitsUMO",
            filter: "DosageORUnitsUMO",
            sortType: "basic",
            
        }, {
            Header: "Total IUs",
            accessor: "Totalcount",
            filter: "Totalcount",
            sortType: "basic",

        },
        {
            Header: "ACQUISITION COST per IU/EU/Gram",
            accessor: "AcquisitionCost",
            filter: "AcquisitionCost",
            sortType: "basic",
         
        },
        {
            Header: "CONTRACT PRICE per IU/EU/Gram",
            accessor: "ContractPrice",
            filter: "ContractPrice",
            sortType: "basic",
         
        },
        {
            Header: "CIBD Extended Amount",
            accessor: "CIBDExtendedAmount",
            filter: "CIBDExtendedAmount",
            sortType: "basic",
         
        },
        {
            Header: "2% Service Fees",
            accessor: "TwoPercentServiceFees",
            filter: "TwoPercentServiceFees",
            sortType: "basic",
         
        },
    ];
    //
    useEffect(() => {
        getServiceFee();
    }, [])
    async function getServiceFee() {
        setLoading(true);
        let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=ServiceFeesQuarterly&TaskTypeCode=AptevoServiceFees`;
        await _HttpServices
            .getData(url)
            .then((data) => {
                const serviceFeeResult = data.data;
                if (serviceFeeResult.length > 0) {
                    serviceFeeResult.map((res) => {
                        res.ReportDate = moment(res.ReportDate).format('MM/DD/YYYY');
                        res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format('MM/DD/YYYY');                          
                        res.AcquisitionCost = res.AcquisitionCost == null ? "$0.00" :"$"+ (res.AcquisitionCost * 1).toFixed(2);
                        res.ContractPrice = res.ContractPrice == null ? "$0.00" :"$"+ (res.ContractPrice * 1).toFixed(2);
                        res.CIBDExtendedAmount = res.CIBDExtendedAmount == null ? "$0.00" :"$"+ (res.CIBDExtendedAmount * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        // res.SaleQTY = res.SaleQTY == null? "0.0000":  (res.SaleQTY*1).toFixed(4);
                        res.DosagORUnitstabs30 = res.DosagORUnitstabs30 == null ? "0.00" :  (res.DosagORUnitstabs30*1).toFixed(2);
                        res.Totalcount = res.Totalcount == null? "0.00":  (res.Totalcount*1).toFixed(2);
                        res.TwoPercentServiceFees = res.TwoPercentServiceFees == null? "$0.00": "$" + (res.TwoPercentServiceFees*1).toFixed(2);
                    })
                }
                setSalesSource(serviceFeeResult);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                // Message = e.response.data.Message;
                // setShowToaster(true);
                setHasError(true);
            });

    }
    
    const EditRecords = () =>{
        localStorage.setItem("salesSource",JSON.stringify(salesSource));
        history.push("/AptevoQuarterlyServiceFeesEdit")
    }
    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Aptevo Quarterly ServiceFees</h2>
                {loading ? <Loader /> : null}
                <div>
                {salesSource.length > 0 &&userData.RoleID === 1 &&
                 (outbounddata.FileSentStatus == "Sent" ? <Button type="submit" onClick={() =>EditRecords()}>Create Reversal</Button> :
                    <Button type="submit" onClick={() =>EditRecords()}>Edit Records</Button>
                    )}
                <Button type="submit" className="ml-2" onClick={() => getExcel(excelColumns,salesSource,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                </div>
            </div>
              {/* Toaster */}
              {/* <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header>
                
                <Toast.Body>{Message}</Toast.Body>
            </Toast> */}
            <Row>
                <Col md={12}>
                    <div className="card pt-2 mb-4">
                        <div className="card-body">
                            <div className="inventory-grid">
                            {hasError ? <p>Error occurred. Unable to load Aptevo Quarterly ServiceFees.</p> :
                                <Fragment>
                                    {salesSource.length > 0 ? (
                                        <ReactTable columns={excelColumns} data={salesSource} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                               }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
              <Col md={12} className="text-right mt-2">
                <Button
                  variant="danger"
                  type="button"
                  className="ml-3"
                   onClick={() => history.goBack()}
                >
                  <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
              </Col>
            </Row>
            <Footer />
        </section>
    );

}

export default AptevoQuarterlyServiceFeesPage;